import React from 'react';
import IteminCart from "./itemincart"
import { IConatinerProps } from "./itemincartinterface";


const IteminCartContainer = (props: IConatinerProps) => {

    return (
        <IteminCart
            cartsDetails={props.cartsDetails}
            handleParentChange={props.handleParentChange}
            handleDeselectAll={props.handleDeselectAll}
            cartToolMenu={props.cartToolMenu}
            isPartNumber={props.isPartNumber}
            SaveOnClick={props.SaveOnClick}
            showAlert={props?.showAlert}
            errorSuccessMessage={props?.errorSuccessMessage}
            ShareOnClick={props.ShareOnClick}
            childCheckboxes={props.childCheckboxes}
            handleErrorClose={props?.handleErrorClose}
            DeleteOnClick={props?.DeleteOnClick}
            itemSummaryDetails={props?.itemSummaryDetails}
            alertType={props?.alertType}
            />
    )
}
export default IteminCartContainer